import { Record } from 'immutable';
export const LogEventMessageFieldDefinitionKeys = {
  FIELD_KEY: 'fieldKey',
  PATH_KEYS_CONSTRUCTOR: 'pathKeysConstructor',
  IS_PRIMARY_RISK_MESSAGE_FIELD: 'isPrimaryRiskMessageField',
  IS_SECONDARY_RISK_MESSAGE_FIELD: 'isSecondaryRiskMessageField'
};
export default class LogEventMessageFieldDefinition extends Record({
  [LogEventMessageFieldDefinitionKeys.FIELD_KEY]: undefined,
  [LogEventMessageFieldDefinitionKeys.PATH_KEYS_CONSTRUCTOR]: undefined,
  [LogEventMessageFieldDefinitionKeys.IS_PRIMARY_RISK_MESSAGE_FIELD]: undefined,
  [LogEventMessageFieldDefinitionKeys.IS_SECONDARY_RISK_MESSAGE_FIELD]: undefined
}, 'LogEventMessageFieldDefinition') {}